export default __webpack_public_path__ + "static/media/b_4.c73daeb6.jpg";